/**
 * Wait a certain number of milliseconds before processing the text command.
 *
 * @param {number} duration Duration in milliseconds
 */
export async function wait (duration) {
    await new Promise((resolve) => {
        setTimeout(resolve, duration)
    })
}



// WEBPACK FOOTER //
// ./src/utilities/misc.js